import {
  MDSBorderRadius,
  MDSTransitions,
  MDSColors,
  MDSFontSizes,
  MDSLineHeights,
  MDSFontWeights,
  MDSLineSpacings,
  MDSSpacings,
  MDSSidebarWidths,
  MDSBorders,
  MDSShadows,
  MDSBreakpoints,
  MDSMediaQueries,
  MDSZIndexes,
} from "@/mds/foundations";
import { Theme } from "@emotion/react";

export const mdsCommonTheme: Theme = {
  colors: MDSColors,
  fontSizes: MDSFontSizes,
  fontWeights: MDSFontWeights,
  borderRadius: MDSBorderRadius,
  lineHeights: MDSLineHeights,
  lineSpacings: MDSLineSpacings,
  transitions: MDSTransitions,
  spacing: MDSSpacings,
  sidebar: MDSSidebarWidths,
  borders: MDSBorders,
  shadows: MDSShadows,
  breakpoints: MDSBreakpoints,
  mediaQueries: MDSMediaQueries,
  zIndex: MDSZIndexes,
};
